var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "tiket-modal",
      attrs: { "hide-footer": "", "no-close-on-backdrop": "" },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function (ref) {
            return [
              _c("h5", [_vm._v("Pendaftaran Berhasil!")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "close",
                  on: {
                    click: function ($event) {
                      return _vm.onClose()
                    },
                  },
                },
                [_vm._v("x")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm._v(" "),
      _c("h6", [
        _vm._v(
          "Silahkan Catat atau Screen Capture untuk Nomor Pendaftaran Anda."
        ),
      ]),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "paleBlueRows", attrs: { id: "tiket-table" } },
        [
          _c("tbody", [
            _c("tr", [_c("td", [_vm._v("Kode Booking")])]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v(_vm._s(_vm.datum.kdBooking))])]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v("No. RM/Nama Pasien")])]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _c("small", [_vm._v(_vm._s(_vm.datum.rm))]),
                _vm._v(" / " + _vm._s(_vm.datum.nama) + "\n                "),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v("No. Antrian Loket")])]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.datum.noAntrianPendaftaran))]),
            ]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v("Poli yang Dituju")])]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.datum.poliTujuan) +
                    "\n                    "
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.datum.dokterTujuan) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v("No. Urut Poli")])]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v(_vm._s(_vm.datum.noAntrianPoli))])]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v("Tanggal Berobat")])]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v(_vm._s(_vm.datum.tanggalBerobat))])]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Estimasi Dilayani di Loket Registrasi")]),
            ]),
            _vm._v(" "),
            _c("tr", [_c("td", [_vm._v(_vm._s(_vm.datum.estimasidilayani))])]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }